import { render, staticRenderFns } from "./BlocoDadosTabsMapaMonitoramentoAgricolaParaguai.vue?vue&type=template&id=5dbe2b87&lang=pug"
import script from "./BlocoDadosTabsMapaMonitoramentoAgricolaParaguai.vue?vue&type=script&lang=js"
export * from "./BlocoDadosTabsMapaMonitoramentoAgricolaParaguai.vue?vue&type=script&lang=js"
import style0 from "./BlocoDadosTabsMapaMonitoramentoAgricolaParaguai.vue?vue&type=style&index=0&id=5dbe2b87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports